/* src/app/bot/voice-agent/voice-agent.component.scss */
:host {
  display: block;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.voice-agent {
  --primary: #253b80;
  --primary-dark: #1e316d;
  --secondary: #344f91;
  --text: #111827;
  --text-secondary: #475569;
  --muted: #6b7280;
  --light-text: #9ca3af;
  --background: #f4f6fa;
  --surface: #ffffff;
  --surface-soft: #f8fafc;
  --border: #e5e7eb;
  --border-light: #edf0f4;
  --success: #16a34a;
  --danger: #dc2626;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  color: var(--text);
  transition: background 0.3s ease, color 0.3s ease;
}
.voice-agent * {
  box-sizing: border-box;
}
.voice-agent button,
.voice-agent input,
.voice-agent select {
  font-family: inherit;
}
.voice-agent button {
  -webkit-tap-highlight-color: transparent;
}
.bg-glow {
  position: absolute;
  width: 520px;
  height: 520px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(37, 59, 128, 0.11) 0%,
      rgba(37, 59, 128, 0.045) 38%,
      transparent 70%);
  filter: blur(25px);
  pointer-events: none;
  z-index: 0;
}
.agent-card {
  position: relative;
  z-index: 2;
  width: min(920px, 100% - 48px);
  height: calc(100% - 100px);
  min-height: 500px;
  margin-top: 2px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease, height 0.3s ease;
}
.back-question-wrapper {
  position: absolute;
  top: 20px;
  left: 24px;
  z-index: 10;
}
.back-question-btn {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 13px;
  border: 1px solid rgba(229, 231, 235, 0.8);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.82);
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
  transition:
    color 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.back-question-btn i {
  font-size: 13px;
}
.back-question-btn:hover {
  color: var(--primary);
  background: #ffffff;
  border-color: rgba(37, 59, 128, 0.18);
  transform: translateX(-2px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.07);
}
.back-question-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.avatar-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 24px 30px;
  text-align: center;
}
.avatar-ring {
  position: relative;
  width: 190px;
  height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    linear-gradient(
      135deg,
      #253b80,
      #344f91,
      #7890c9) border-box;
  border: 4px solid transparent;
  box-shadow: 0 0 0 12px rgba(37, 59, 128, 0.035), 0 20px 50px rgba(37, 59, 128, 0.14);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}
.avatar-ring::before {
  content: "";
  position: absolute;
  inset: -14px;
  border-radius: 50%;
  border: 1px solid rgba(37, 59, 128, 0.14);
  animation: avatarPulse 3s ease-in-out infinite;
}
.avatar-ring::after {
  content: "";
  position: absolute;
  inset: 8px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(37, 59, 128, 0.1),
      transparent 68%);
  pointer-events: none;
}
.avatar-img {
  position: relative;
  z-index: 2;
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
}
.avatar-ring.agent-speaking {
  transform: scale(1.04);
  box-shadow:
    0 0 0 14px rgba(37, 59, 128, 0.045),
    0 0 50px rgba(37, 59, 128, 0.22),
    0 25px 60px rgba(37, 59, 128, 0.15);
}
.avatar-ring.agent-speaking::before {
  animation: avatarPulse 1.2s ease-in-out infinite, speakingRing 1.5s linear infinite;
}
.avatar-ring.user-speaking {
  box-shadow:
    0 0 0 14px rgba(52, 79, 145, 0.045),
    0 0 45px rgba(52, 79, 145, 0.2),
    0 25px 60px rgba(52, 79, 145, 0.14);
}
.avatar-section h2 {
  margin: 28px 0 9px;
  color: var(--text);
  font-size: 25px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.4px;
}
.avatar-section p {
  max-width: 440px;
  margin: 0;
  color: var(--muted);
  font-size: 15px;
  line-height: 1.65;
}
.transcript-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 48px 4px 0;
}
.transcript-avatar {
  padding-top: 55px;
}
.transcript-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 12px 20px;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.transcript-container::-webkit-scrollbar {
  width: 5px;
}
.transcript-container::-webkit-scrollbar-track {
  background: transparent;
}
.transcript-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.message-row {
  width: 100%;
  display: flex;
  margin-bottom: 18px;
  animation: messageIn 0.25s ease;
}
.message-row.agent {
  justify-content: flex-start;
}
.message-row.user {
  justify-content: flex-end;
}
.message-content {
  max-width: 74%;
  min-width: 0;
}
.message-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  background: transparent !important;
  color: #253b80 !important;
}
.message-header .name {
  color: var(--muted);
  font-size: 12px;
  font-weight: 650;
}
.message-row.user .message-header {
  justify-content: flex-end;
}
.message-row.user .message-header .name {
  color: var(--primary);
}
.bubble {
  max-width: 100%;
  padding: 12px 16px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.message-row.agent .bubble {
  background: #ffffff;
  color: #334155;
  border: 1px solid var(--border);
  border-top-left-radius: 5px;
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.045);
}
.message-row.user .bubble {
  background:
    linear-gradient(
      135deg,
      #253b80,
      #344f91);
  color: #ffffff;
  border-top-right-radius: 5px;
  box-shadow: 0 8px 20px rgba(37, 59, 128, 0.18);
}
.input-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 4px 2px;
  padding: 7px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.055);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.input-wrapper:focus-within {
  border-color: rgba(37, 59, 128, 0.3);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07), 0 8px 25px rgba(15, 23, 42, 0.055);
}
.input-wrapper input {
  flex: 1;
  min-width: 0;
  height: 42px;
  padding: 0 13px;
  border: 0;
  outline: none;
  background: transparent;
  color: var(--text);
  font-size: 14px;
}
.input-wrapper input::placeholder {
  color: var(--light-text);
}
.input-wrapper input:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.input-wrapper button {
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 11px;
  background: var(--primary);
  color: #ffffff;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.input-wrapper button i {
  font-size: 15px;
}
.input-wrapper button:hover:not(:disabled) {
  background: var(--primary-dark);
  transform: translateY(-1px);
}
.input-wrapper button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.input-wrapper button:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.agent-footer {
  position: relative;
  z-index: 5;
  width: 100%;
  min-height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 20px;
  flex-wrap: wrap;
}
.voice-select {
  width: 210px;
  flex: 0 0 210px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.voice-select label {
  display: block;
  margin: 0;
  padding-left: 2px;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 650;
  line-height: 1.2;
}
.voice-select select {
  width: 100%;
  height: 44px;
  padding: 0 36px 0 13px;
  border: 1px solid #d9dee8;
  border-radius: 10px;
  outline: none;
  background: #ffffff;
  color: var(--text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.voice-select select:hover:not(:disabled) {
  border-color: #bcc5d3;
}
.voice-select select:focus {
  border-color: rgba(37, 59, 128, 0.45);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.voice-select select:disabled {
  background: #f8fafc;
  color: var(--light-text);
  cursor: not-allowed;
}
.voice-select select option {
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  padding: 10px;
}
.voice-select select option:hover {
  background: #253b80 !important;
  color: #eef2ff !important;
}
.voice-select select option:checked {
  background: #253b80 !important;
  color: #ffffff !important;
}
.circle-btn {
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.07);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.circle-btn img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.circle-btn:hover {
  background: #ffffff;
  border-color: rgba(37, 59, 128, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 9px 22px rgba(15, 23, 42, 0.11);
}
.circle-btn:active {
  transform: scale(0.94);
}
.circle-btn.active {
  background: #eef2ff;
  border-color: rgba(37, 59, 128, 0.25);
}
.circle-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.14);
  outline-offset: 2px;
}
.circle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.call-btn {
  flex: 0 0 auto;
  min-width: 132px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  margin-left: 4px;
  padding: 0 21px;
  border: 0;
  border-radius: 14px;
  background:
    linear-gradient(
      135deg,
      var(--primary),
      var(--secondary));
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 9px 22px rgba(37, 59, 128, 0.2);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.call-btn i {
  font-size: 15px;
}
.call-btn:hover:not(:disabled) {
  background:
    linear-gradient(
      135deg,
      var(--primary-dark),
      var(--primary));
  transform: translateY(-2px);
  box-shadow: 0 13px 28px rgba(37, 59, 128, 0.25);
}
.call-btn:active:not(:disabled) {
  transform: translateY(0);
}
.call-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.18);
  outline-offset: 3px;
}
.call-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.call-btn.connected {
  flex: 0 0 50px;
  width: 50px;
  min-width: 50px;
  height: 50px;
  margin-left: 5px;
  padding: 0;
  border-radius: 50%;
  background:
    linear-gradient(
      135deg,
      #ef4444,
      #dc2626);
  box-shadow: 0 9px 22px rgba(220, 38, 38, 0.2);
}
.call-btn.connected:hover:not(:disabled) {
  background:
    linear-gradient(
      135deg,
      #dc2626,
      #b91c1c);
  box-shadow: 0 13px 28px rgba(220, 38, 38, 0.26);
}
.call-btn.connecting {
  background: #64748b;
  box-shadow: none;
  cursor: wait;
}
.voice-agent.connected .bg-glow {
  background:
    radial-gradient(
      circle,
      rgba(37, 59, 128, 0.15) 0%,
      rgba(52, 79, 145, 0.055) 40%,
      transparent 70%);
}
@keyframes avatarPulse {
  0%, 100% {
    transform: scale(0.98);
    opacity: 0.45;
  }
  50% {
    transform: scale(1.04);
    opacity: 1;
  }
}
@keyframes speakingRing {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.08);
    opacity: 0.2;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}
@keyframes messageIn {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 991px) {
  .agent-card {
    width: calc(100% - 32px);
    height: calc(100% - 135px);
    margin-top: 12px;
    padding: 18px;
    border-radius: 22px;
  }
  .avatar-ring {
    width: 165px;
    height: 165px;
  }
  .avatar-img {
    width: 130px;
    height: 130px;
  }
  .message-content {
    max-width: 80%;
  }
  .agent-footer {
    min-height: 90px;
    gap: 10px;
    padding: 12px 16px;
  }
  .voice-select {
    width: 190px;
    flex-basis: 190px;
  }
}
@media (max-width: 575px) {
  :host {
    height: 100dvh;
  }
  .voice-agent {
    height: 100dvh;
    min-height: 100dvh;
    padding: 0;
  }
  .bg-glow {
    width: 340px;
    height: 340px;
    top: 42%;
  }
  .agent-card {
    width: calc(100% - 16px);
    height: calc(100% - 110px);
    min-height: 0;
    margin-top: 8px;
    padding: 10px;
    border-radius: 18px;
  }
  .back-question-wrapper {
    top: 12px;
    left: 12px;
  }
  .back-question-btn {
    min-height: 38px;
    padding: 7px 10px;
    font-size: 11px;
  }
  .back-question-btn span {
    display: none;
  }
  .back-question-btn i {
    font-size: 13px;
  }
  .avatar-section {
    padding: 45px 18px 25px;
  }
  .avatar-ring {
    width: 135px;
    height: 135px;
    border-width: 3px;
  }
  .avatar-img {
    width: 108px;
    height: 108px;
  }
  .avatar-section h2 {
    margin-top: 23px;
    font-size: 21px;
  }
  .avatar-section p {
    max-width: 290px;
    font-size: 13px;
  }
  .transcript-wrapper {
    padding: 40px 0 0;
  }
  .transcript-avatar {
    padding-top: 42px;
  }
  .transcript-container {
    padding: 8px 5px 14px;
  }
  .message-row {
    margin-bottom: 14px;
  }
  .message-content {
    max-width: 90%;
  }
  .message-header {
    margin-bottom: 4px;
  }
  .message-header .name {
    font-size: 11px;
  }
  .bubble {
    padding: 10px 13px;
    font-size: 13.5px;
    line-height: 1.5;
    border-radius: 14px;
  }
  .input-wrapper {
    margin: 5px 0 0;
    padding: 5px;
    border-radius: 13px;
  }
  .input-wrapper input {
    height: 39px;
    padding: 0 9px;
    font-size: 13px;
  }
  .input-wrapper button {
    width: 39px;
    height: 39px;
    flex-basis: 39px;
    border-radius: 10px;
  }
  .agent-footer {
    width: calc(100% - 16px);
    min-height: 102px;
    gap: 8px;
    margin-top: 4px;
    padding: 9px 10px;
    border-radius: 15px;
  }
  .voice-select {
    width: calc(50% - 4px);
    flex: 0 0 calc(50% - 4px);
    gap: 5px;
  }
  .voice-select label {
    font-size: 11px;
  }
  .voice-select select {
    height: 40px;
    padding: 0 28px 0 10px;
    border-radius: 9px;
    font-size: 12px;
  }
  .circle-btn {
    flex: 0 0 43px;
    width: 43px;
    height: 43px;
  }
  .circle-btn img {
    width: 19px;
    height: 19px;
  }
  .call-btn:not(.connected) {
    min-width: 112px;
    height: 44px;
    margin-left: 0;
    padding: 0 16px;
    border-radius: 13px;
    font-size: 13px;
  }
  .call-btn.connected {
    flex: 0 0 45px;
    width: 45px;
    min-width: 45px;
    height: 45px;
    margin-left: 2px;
  }
}
@media (max-width: 380px) {
  .agent-card {
    width: calc(100% - 10px);
    height: calc(100% - 105px);
    padding: 8px;
  }
  .agent-footer {
    width: calc(100% - 10px);
    gap: 6px;
    padding: 8px;
  }
  .voice-select {
    width: calc(50% - 3px);
    flex-basis: calc(50% - 3px);
  }
  .voice-select select {
    height: 38px;
    font-size: 11px;
  }
  .circle-btn {
    flex-basis: 40px;
    width: 40px;
    height: 40px;
  }
  .circle-btn img {
    width: 18px;
    height: 18px;
  }
  .call-btn:not(.connected) {
    min-width: 104px;
    height: 42px;
    font-size: 12px;
  }
  .call-btn.connected {
    flex-basis: 42px;
    width: 42px;
    min-width: 42px;
    height: 42px;
  }
  .avatar-ring {
    width: 120px;
    height: 120px;
  }
  .avatar-img {
    width: 96px;
    height: 96px;
  }
  .avatar-section h2 {
    font-size: 19px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .voice-agent *,
  .voice-agent *::before,
  .voice-agent *::after {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
.document-dropdown {
  position: absolute;
  bottom: calc(100% + 10px);
  top: auto;
  right: 0;
  width: 350px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  z-index: 9999;
}
.document-selector {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.document-dropdown {
  position: absolute;
  right: 0;
  bottom: calc(100% + 12px);
  top: auto;
  width: 360px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
  overflow: hidden;
  z-index: 5000;
  animation: documentDropdownIn 0.18s ease-out;
}
@keyframes documentDropdownIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.dropdown-icon {
  display: flex;
  justify-content: center;
  padding-top: 18px;
}
.dropdown-icon img {
  width: 46px;
  height: 46px;
  padding: 9px;
  border-radius: 12px;
  background: #f1f4ff;
  object-fit: contain;
}
.dropdown-title {
  text-align: center;
  padding: 10px 16px 15px;
}
.dropdown-title h4 {
  margin: 0;
  color: #1f2937;
  font-size: 15px;
  font-weight: 600;
}
.dropdown-title span {
  display: block;
  margin-top: 4px;
  color: #98a1b2;
  font-size: 12px;
}
.document-search {
  height: 40px;
  margin: 0 12px 10px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 12px;
  background: #f8f9fb;
  border: 1px solid #e6e9ef;
  border-radius: 9px;
  transition: 0.2s ease;
}
.document-search:focus-within {
  background: #ffffff;
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.document-search i {
  color: #9aa3b2;
  font-size: 13px;
}
.document-search input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #374151;
  font-family: inherit;
}
.document-search input::placeholder {
  color: #a5adba;
}
.document-list {
  max-height: 280px;
  overflow-y: auto;
  padding: 2px 8px 10px;
  scrollbar-width: thin;
}
.document-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  margin-bottom: 2px;
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}
.document-item:hover {
  background: #f5f7fb;
}
.document-item.active {
  background: #eef2ff;
}
.document-item.active .document-name {
  color: #253b80;
  font-weight: 600;
}
.document-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff1f1;
  color: #d64545;
}
.document-icon i {
  font-size: 16px;
}
.document-info {
  min-width: 0;
  flex: 1;
}
.document-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #374151;
}
.document-meta {
  margin-top: 3px;
  font-size: 11px;
  color: #9aa3b2;
}
.selected-icon {
  color: #253b80;
  font-size: 14px;
}
.document-preview-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  background: rgba(15, 23, 42, 0.68);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  animation: previewOverlayIn 0.2s ease-out;
}
@keyframes previewOverlayIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.document-preview-modal {
  width: min(1200px, 96vw);
  height: min(90vh, 850px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f7fb;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 18px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.3);
  animation: previewModalIn 0.22s ease-out;
}
@keyframes previewModalIn {
  from {
    opacity: 0;
    transform: translateY(15px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.document-preview-header {
  min-height: 70px;
  flex-shrink: 0;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.preview-document-info {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.preview-file-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2ff;
}
.preview-file-icon img {
  width: 25px;
  height: 25px;
  object-fit: contain;
}
.preview-file-details {
  min-width: 0;
}
.preview-file-details h3 {
  max-width: 600px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1f2937;
  font-size: 15px;
  font-weight: 600;
}
.preview-file-details span {
  display: block;
  margin-top: 4px;
  color: #8b95a5;
  font-size: 11px;
}
.preview-file-details .separator {
  display: inline;
  margin: 0 5px;
}
.preview-header-actions {
  display: flex;
  align-items: center;
  gap: 7px;
}
.preview-action-btn,
.preview-close-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #e1e5eb;
  background: #ffffff;
  color: #596273;
  cursor: pointer;
  transition: 0.18s ease;
}
.preview-action-btn:hover:not(:disabled),
.preview-close-btn:hover:not(:disabled) {
  background: #f4f6fa;
  border-color: #cfd5df;
  color: #253b80;
}
.preview-action-btn:disabled,
.preview-close-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.preview-close-btn {
  margin-left: 5px;
}
.preview-close-btn:hover {
  color: #dc2626;
  background: #fff5f5;
  border-color: #fecaca;
}
.document-preview-body {
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 11px;
  background: #eef1f6;
}
.document-preview-frame {
  width: 100%;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #dfe3ea;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(15, 23, 42, 0.1);
}
.document-preview-frame iframe {
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
}
.document-side-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dfe3ea;
  border-radius: 50%;
  background: #ffffff;
  color: #253b80;
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.12);
  cursor: pointer;
  z-index: 5;
  transition: 0.18s ease;
}
.document-side-nav:hover:not(:disabled) {
  background: #253b80;
  border-color: #253b80;
  color: #ffffff;
  transform: translateY(-50%) scale(1.05);
}
.document-side-nav:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.document-side-nav--left {
  left: 12px;
}
.document-side-nav--right {
  right: 12px;
}
.document-no-preview {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8b95a5;
}
.no-preview-icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  border-radius: 50%;
  background: #f1f3f7;
}
.no-preview-icon i {
  font-size: 30px;
}
.document-no-preview h4 {
  margin: 0;
  color: #4b5563;
  font-size: 15px;
}
.document-no-preview p {
  margin: 6px 0 0;
  color: #9aa3b2;
  font-size: 12px;
}
.document-preview-footer {
  min-height: 58px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
}
.document-position {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #737d8d;
  font-size: 12px;
}
.position-divider {
  color: #c1c7d0;
}
.document-footer-actions {
  display: flex;
  gap: 8px;
}
.document-footer-btn {
  height: 34px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #dfe3ea;
  border-radius: 7px;
  background: #ffffff;
  color: #596273;
  font-size: 12px;
  cursor: pointer;
  transition: 0.18s ease;
}
.document-footer-btn:hover:not(:disabled) {
  background: #f5f7fb;
  color: #253b80;
}
.document-footer-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.document-footer-btn.primary {
  background: #253b80;
  border-color: #253b80;
  color: #ffffff;
}
.document-footer-btn.primary:hover:not(:disabled) {
  background: #1d2f69;
}
@media (max-width: 768px) {
  .document-dropdown {
    width: 320px;
    right: -5px;
  }
  .document-preview-overlay {
    padding: 10px;
  }
  .document-preview-modal {
    width: 100%;
    height: 94vh;
    border-radius: 14px;
  }
  .document-preview-header {
    padding: 0 12px;
  }
  .preview-file-details h3 {
    max-width: 180px;
  }
  .document-preview-body {
    padding: 10px 45px;
  }
  .document-side-nav {
    width: 36px;
    height: 36px;
  }
  .document-side-nav--left {
    left: 5px;
  }
  .document-side-nav--right {
    right: 5px;
  }
  .document-preview-footer {
    padding: 0 12px;
  }
  .document-footer-btn {
    padding: 0 9px;
  }
  .document-footer-btn span {
    display: none;
  }
}
@media (max-width: 480px) {
  .document-dropdown {
    position: fixed;
    right: 10px;
    bottom: 75px;
    width: calc(100vw - 20px);
  }
  .preview-header-actions {
    gap: 4px;
  }
  .preview-action-btn {
    width: 32px;
    height: 32px;
  }
  .preview-close-btn {
    width: 32px;
    height: 32px;
  }
  .preview-file-icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .preview-file-details h3 {
    max-width: 130px;
    font-size: 13px;
  }
  .document-preview-body {
    padding: 8px 40px;
  }
  .document-preview-footer {
    min-height: 52px;
  }
  .document-position {
    display: none;
  }
}
/*# sourceMappingURL=voice-agent.component.css.map */
